import { useState, useEffect, useMemo } from "react";
import dayjs from "dayjs";
import swal from "sweetalert";

import Modal from "../../../myfin_v2/elements/Modal";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { Button } from "../../../myfin_v2/elements/Button";
import commoncss from "../../../myfin_v2/css/common.module.css";
import CommonDatePicker from "../../elements/CommonDatePicker";

import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";
import { ReactComponent as DeleteGreyIcon } from "../../../myfin_v2/assets/icons/deleteGrey.svg";
import { ReactComponent as PlusPrimaryIcon } from "../../../myfin_v2/assets/icons/plusprimary.svg";

import ConsolDropdown from "../../elements/ConsolDropdown";
import {
  addConsolManualAdjustmentApiHandler,
  editConsolManualAdjustmentApiHandler,
  getConsolPopulateFSDetailsApiHandler,
  getPopulateFSFormulaOptions,
  getConsolAdjustmentOptionsApiHandler,
  updateAutoAdjustmentMappingApiHandler,
  updateICEMappingApiHandler
} from "../../../WorkSpace/Components/ApiServices/apiHandler";

const parseAdjustmentDate = (dateStr) => {
  if (!dateStr) return null;
  if (typeof dateStr === "string" && /^\d{2}-\d{2}-\d{4}$/.test(dateStr)) {
    const [d, m, y] = dateStr.split("-");
    const parsed = dayjs(`${y}-${m}-${d}`);
    return parsed.isValid() ? parsed : null;
  }
  const parsed = dayjs(dateStr);
  return parsed.isValid() ? parsed : null;
};

const normalizeString = (str) => {
  if (!str) return "";
  return String(str)
    .replace(/[-\u2012\u2013\u2014\u2015]/g, "-")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();
};

const CreateEditEntryModal = ({
  consolID,
  handleClose,
  editData,
  getManualAdjustments,
  projectID,
  type = "manual",
  getInterCompanyEliminations,
}) => {
  /* -------------------- BASIC STATE -------------------- */
  const [date, setDate] = useState(
    editData?.adjustmentDate ? parseAdjustmentDate(editData.adjustmentDate) : null
  );
  const [remarks, setRemarks] = useState(editData?.remarks || "");

  const [optionsData, setOptionsData] = useState([]);

  const [particulars, setParticulars] = useState([
    {
      levelone: null,
      levelTwo: null,
      levelThree: null,
      socieRow: null,
      currentAmount: "",
      previousAmount: "",
    },
  ]);

  const formatIndianNumber = (value) => {
  if (value === null || value === undefined || value === "") return "";

  const num = Number(value);

  if (isNaN(num)) return value;

  const formatted = Math.abs(num).toLocaleString("en-IN", {
    maximumFractionDigits: 2,
  });

  return num < 0 ? `(${formatted})` : formatted;
};
  /* -------------------- LOAD POPULATE FS TREE -------------------- */
  // useEffect(() => {
  //   Promise.all([
  //     getConsolPopulateFSDetailsApiHandler({
  //       category: "PL",
  //       consolID,
  //     }),
  //     getConsolPopulateFSDetailsApiHandler({
  //       category: "BS",
  //       consolID,
  //     }),
  //   ])
  //     .then(([plRes, bsRes]) => {
  //       const plData = plRes?.data?.data || [];
  //       const bsData = bsRes?.data?.data || [];

  //       setOptionsData([...bsData, ...plData]);
  //     })
  //     .catch(() => {
  //       swal("Error", "Unable to load FS structure", "error");
  //     });
  // }, [consolID]);
  useEffect(() => {
    console.log("consolID =", consolID);

    getConsolAdjustmentOptionsApiHandler({ consolID })
      .then((res) => {
        console.log("adjustmentOptions response", res.data);
        const resData = res?.data?.data || res?.data?.options || res?.data || [];
        
        if (resData && typeof resData === "object" && !Array.isArray(resData)) {
          const bs = resData.bs || [];
          const pl = resData.pl || [];
          setOptionsData([...bs, ...pl]);
        } else if (Array.isArray(resData)) {
          setOptionsData(resData);
        } else {
          setOptionsData([]);
        }
      })
      .catch((err) => {
        console.error("Failed to load adjustment options:", err);
        swal("Error", "Unable to load adjustment options", "error");
      });
  }, [consolID]);
  /* -------------------- OPTIONS -------------------- */
 const getNodeLabel = (node) => {
  if (!node) return "";

  if (typeof node === "string") return node;

  return (
    node.levelOne ||
    node.levelTwo ||
    node.levelThree ||
    node.name ||
    node.particular ||
    node.section ||
    node.subSection ||
    ""
  );
};
  const getNodeChildren = (node) => {
    if (!node) return [];
    if (typeof node === "string") return [];
    return node.subgroup || node.subGroup || node.subSections || node.rows || [];
  };

  const level1Options = useMemo(
    () =>
      optionsData.map((item) => ({
        label: getNodeLabel(item),
        value: item,
      })),
    [optionsData]
  );
  /* -------------------- MAP EDIT DATA → UI STATE -------------------- */
  useEffect(() => {
    if (!editData || optionsData.length === 0) return;

    const mapped = editData.adjustments.map((adj) => {
      const normLvl1 = normalizeString(adj.levelOne);
      const lvl1 = optionsData.find((o) => normalizeString(getNodeLabel(o)) === normLvl1) || adj.levelOne || null;

      const normLvl2 = normalizeString(adj.levelTwo);
      const lvl2 = (lvl1 && typeof lvl1 !== "string") 
        ? (getNodeChildren(lvl1).find((s) => normalizeString(getNodeLabel(s)) === normLvl2) || adj.levelTwo || null)
        : (adj.levelTwo || null);

      const normLvl3 = normalizeString(adj.levelThree);
      const lvl3 = (lvl2 && typeof lvl2 !== "string") 
        ? (getNodeChildren(lvl2).find((s) => normalizeString(getNodeLabel(s)) === normLvl3) || adj.levelThree || null)
        : (adj.levelThree || null);

      return {
        levelone: lvl1,
        levelTwo: lvl2,
        levelThree: lvl3,
        currentAmount: adj.currentYear,
        previousAmount: adj.previousYear,
      };
    });

    setParticulars(mapped);
  }, [editData, optionsData]);

  /* -------------------- ROW HANDLERS -------------------- */
  const handleChange = (index, field, value) => {
    const updated = [...particulars];
    updated[index][field] = value;
    setParticulars(updated);
  };

  const handleAddParticular = () => {
    setParticulars([
      ...particulars,
      {
        levelone: null,
        levelTwo: null,
        levelThree: null,
        socieRow: null,
        currentAmount: "",
        previousAmount: "",
      },
    ]);
  };

  const handleRemoveParticular = (index) => {
    setParticulars(particulars.filter((_, i) => i !== index));
  };

  /* -------------------- SUBMIT -------------------- */
  const handleSubmit = () => {
    if (type === "auto") {
      const payload = {
        adjustments: particulars.map((p) => ({
          levelOne: getNodeLabel(p.levelone),
          levelTwo: getNodeLabel(p.levelTwo),
          levelThree: getNodeLabel(p.levelThree),
        })),
      };

      updateAutoAdjustmentMappingApiHandler(
        { consolID: consolID, autoAdjustmentID: editData?.autoAdjustmentID || editData?._id },
        payload
      )
        .then((response) => {
          if (response?.data?.success === true) {
            handleClose();
            if (getManualAdjustments) getManualAdjustments();
            swal("Auto Adjustment updated successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to update Auto Adjustment",
              "error"
            );
          }
        })
        .catch((error) => {
          if (getManualAdjustments) getManualAdjustments();
          swal(
            "Error",
            error?.response?.data?.error || "Unable to update Auto Adjustment",
            "error"
          );
        });
    } else if (type === "ice") {
      const payload = {
        adjustments: particulars.map((p) => ({
          levelOne: getNodeLabel(p.levelone),
          levelTwo: getNodeLabel(p.levelTwo),
          levelThree: getNodeLabel(p.levelThree),
        })),
      };

      updateICEMappingApiHandler(
        { consolID: consolID, iceID: editData?._id },
        payload
      )
        .then((response) => {
          if (response?.data?.success === true) {
            handleClose();
            if (getInterCompanyEliminations) getInterCompanyEliminations();
            swal("ICE Adjustment updated successfully", "", "success");
          } else {
            swal(
              "Error",
              response?.data?.error || "Unable to update ICE Adjustment",
              "error"
            );
          }
        })
        .catch((error) => {
          if (getInterCompanyEliminations) getInterCompanyEliminations();
          swal(
            "Error",
            error?.response?.data?.error || "Unable to update ICE Adjustment",
            "error"
          );
        });
    } else {
      const payload = {
        adjustmentDate: date ? dayjs(date).format("DD-MM-YYYY") : null,
        remarks,
        adjustments: particulars.map((p) => ({
          levelOne: getNodeLabel(p.levelone),
          levelTwo: getNodeLabel(p.levelTwo),
          levelThree: getNodeLabel(p.levelThree),
          currentYear: p.currentAmount,
          previousYear: p.previousAmount,
        })),
      };

      if (editData) {
        editConsolManualAdjustmentApiHandler(
          { consolID: consolID, manualAdjustmentID: editData?._id },
          payload
        )
          .then((response) => {
            if (response?.data?.success === true) {
              handleClose();
              getManualAdjustments();
              swal("Adjustment updated successful", "", "success");
            } else {
              swal(
                "Error",
                response?.data?.error || "Unable to update Adjustment",
                "error"
              );
            }
          })
          .catch((error) => {
            getManualAdjustments();
            swal(
              "Error",
              error?.response?.data?.error || "Unable to update Adjustment",
              "error"
            );
          });
      } else {
        addConsolManualAdjustmentApiHandler({ consolID: consolID }, payload)
          .then((response) => {
            if (response?.data?.success === true) {
              handleClose();
              getManualAdjustments();
              swal("Adjustment added successful", "", "success");
            } else {
              swal(
                "Error",
                response?.data?.error || "Unable to add Adjustment",
                "error"
              );
            }
          })
          .catch((error) => {
            getManualAdjustments();
            swal(
              "Error",
              error?.response?.data?.error || "Unable to add Adjustment",
              "error"
            );
          });
      }
    }
  };

  /* -------------------- UI -------------------- */
  return (
    <Modal
      width="650px"
      title={(editData || type === "auto" || type === "ice") ? "Edit Entry" : "Create Entry"}
      bodycss={commoncss.unsetPadding}
      headerActions={<CloseIcon className="clickable" onClick={handleClose} />}
      footerActions={
        <>
          <Button
            btnColor={buttoncss.secondary}
            label="Cancel"
            onClick={handleClose}
          />
          <Button
            btnColor={buttoncss.primary}
            label={(editData || type === "auto" || type === "ice") ? "Update" : "Create Entry"}
            onClick={handleSubmit}
          />
        </>
      }
    >
      <div className={commoncss.pd1530}>
        {/* DATE */}
        <InputGroup
          label="Choose Date"
          class2_="mt-1"
          inputs={[
            <>
              <CommonDatePicker
                value={date}
                onChange={(d) => {
                  if (!editData) setDate(d);
                }}
                placeholder="DD-MMM-YYYY"
                containerClass={`${commoncss.datePickerContainer} ${!editData ? commoncss.clickable : commoncss.noActions}`}
                iconStyle={{ display: "none" }}
                inputStyle={{ height: "37px" }}
              />
              <span className="icon" style={{ marginTop: "-4px" }}>
                <CalenderIcon width={20} height={20} />
              </span>
            </>,
          ]}
        />

        {/* REMARKS */}
        <InputGroup
          label="Remarks"
          inputs={[
            <textarea
              rows={3}
              value={remarks}
              onChange={(e) => setRemarks(e.target.value)}
              placeholder="Enter remarks"
              className={`${commoncss.placeholderStyle} ${editData ? commoncss.greyInput : ""}`}
              disabled={!!editData}
            />,
          ]}
        />

        {/* ADJUSTMENTS */}
        {particulars.map((item, index) => {
          const isOtherEquity =
            getNodeLabel(item.levelTwo)?.toLowerCase() === "other equity";
          console.log("Level 2 Selected:", item.levelTwo);
          console.log("Level 3 Data:", item.levelTwo?.subgroup);

          return (
            <div
              key={index}
              style={{
                border: "1px solid #EAEEED",
                padding: "10px",
                borderRadius: "10px",
                marginTop: "15px",
                position: "relative",
                zIndex: particulars.length - index,
              }}
            >
              {/* LEVEL 1 */}
              <div style={{ position: "relative", zIndex: 3 }}>
                <InputGroup
                  label={
                    <div className="attachments-button-label">
                      <span>Level 1</span>
                      {particulars.length > 1 && (
                        <span
                          className="mb-2"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleRemoveParticular(index)}
                        >
                          <DeleteGreyIcon />
                        </span>
                      )}
                    </div>
                  }
                  inputs={[
                    <ConsolDropdown
                      options={level1Options}
                      selected={
                        item.levelone
                          ? { label: getNodeLabel(item.levelone), value: item.levelone }
                          : null
                      }
                      onSelect={(sel) => {
                        handleChange(index, "levelone", sel ? sel.value : null);
                        handleChange(index, "levelTwo", null);
                        handleChange(index, "levelThree", null);
                      }}
                      placeHolder="Select Level 1"
                      className={commoncss.placeholderStyle}
                      isEditable={true}
                    />,
                  ]}
                />
              </div>

              {/* LEVEL 2 */}
              <div style={{ position: "relative", zIndex: 2 }}>
                <InputGroup
                  label="Level 2"
                  inputs={[
                    <ConsolDropdown
                      options={
                        getNodeChildren(item.levelone).map((s) => ({
                          label: getNodeLabel(s),
                          value: s,
                        }))
                      }
                      selected={
                        item.levelTwo
                          ? { label: getNodeLabel(item.levelTwo), value: item.levelTwo }
                          : null
                      }
                      onSelect={(sel) => {
                        handleChange(index, "levelTwo", sel ? sel.value : null);
                        handleChange(index, "levelThree", null);
                      }}
                      disabled={!item.levelone}
                      placeHolder="Select Level 2"
                      className={commoncss.placeholderStyle}
                      isEditable={true}
                    />,
                  ]}
                />
              </div>

              {/* LEVEL 3 */}
              <div style={{ position: "relative", zIndex: 1}}>
                <InputGroup
                  label="Level 3"
                  inputs={[
                    <ConsolDropdown
                      options={
                        getNodeChildren(item.levelTwo).map((s) => ({
                          label: getNodeLabel(s),
                          value: s,
                        }))
                      }
                      selected={
                        item.levelThree
                          ? {
                              label: getNodeLabel(item.levelThree),
                              value: item.levelThree,
                            }
                          : null
                      }
                      onSelect={(sel) =>
                        handleChange(index, "levelThree", sel ? sel.value : null)
                      }
                      disabled={!item.levelTwo}
                      placeHolder="Select Level 3"
                      className={commoncss.placeholderStyle}
                      isEditable={true}
                    />,
                  ]}
                />
              </div>

              {isOtherEquity && (
                <div style={{ position: "relative", zIndex: 1.5 }}>
                  <InputGroup
                    label="SOCIE Row"
                    inputs={[
                      <ConsolDropdown
                        options={[]}
                        selected={item.socieRow}
                        onSelect={(sel) =>
                          handleChange(index, "socieRow", sel)
                        }
                        placeHolder="Select Socie Row"
                        className={commoncss.placeholderStyle}
                        isEditable={true}
                      />,
                    ]}
                  />
                </div>
              )}

              <div className="row">
                <div className="col-md-6" style={{ paddingRight: "7px" }} >
                  <InputGroup
                    label="Current Year Amount"
                    inputs={[
                      <input
                        type="text"
                        placeholder="Enter Amount"
                        className={commoncss.placeholderStyle}
                        value={
                          type === "auto" || type === "ice"
                            ? formatIndianNumber(item.currentAmount)
                            : item.currentAmount
                        }
                        disabled={type === "auto" || type === "ice"}
                        onChange={(e) =>
                          handleChange(index, "currentAmount", e.target.value)
                        }
                      />,
                    ]}
                  />
                </div>
                <div className="col-md-6" style={{ paddingLeft: "7px" }}>
                  <InputGroup
                    label="Previous Year Amount"
                    inputs={[
                      <input
                        type="text"
                        placeholder="Enter Amount"
                        value={
                          type === "auto" || type === "ice"
                            ? formatIndianNumber(item.previousAmount)
                            : item.previousAmount
                        }
                        disabled={type === "auto" || type === "ice"}
                        className={commoncss.placeholderStyle}
                        onChange={(e) =>
                          handleChange(index, "previousAmount", e.target.value)
                        }
                      />,
                    ]}
                  />
                </div>
              </div>
            </div>
          );
        })}

        <div
          onClick={handleAddParticular}
          style={{
            color: "#2D8861",
            fontSize: "14px",
            marginTop: "10px",
            cursor: "pointer",
          }}
        >
          <PlusPrimaryIcon /> Add Field
        </div>
      </div>
    </Modal>
  );
};

export default CreateEditEntryModal;
